export default __webpack_public_path__ + "static/pivot-e235af343200039439f88eb6e0404c45.jpg";